// var tt                  = require("babylon").tokTypes;
// var tt                  = require("babel-core").acorn.tokTypes;
var convertTemplateType = require("./convertTemplateType");
var toToken = require("./toToken");

module.exports = function (tokens, tt) {
  // transform tokens to type "Template"
  convertTemplateType(tokens, tt);
  var transformedTokens = tokens.filter(function (token) {
    return token.type !== "CommentLine" && token.type !== "CommentBlock";
  });

  for (var i = 0, l = transformedTokens.length; i < l; i++) {
    transformedTokens[i] = toToken(transformedTokens[i], tt);
  }

  return transformedTokens;
};


//////////////////
// WEBPACK FOOTER
// ./~/acorn-to-esprima/src/toTokens.js
// module id = 1939
// module chunks = 0